import { useSearchParams } from 'react-router-dom';
import { SKELETON_DEBUG_CHART_HEIGHT } from '@/features/executionRuns/pages/executionRunsCharts';
import { ListPageSkeletonPreset } from '@/ui/composites';
import { PageShell } from '@/ui/primitives/PageShell';
import { ExecutionRunsPageContent } from './ExecutionRunsPageContent';
import type { ReactElement } from 'react';

export const ExecutionRunsPage = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const skeletonDebug = searchParams.get('skeleton') === '1';
  if (skeletonDebug) {
    return (
      <PageShell maxWidth="xl" paddingX="lg" paddingY="xl" paddingTop="lg" paddingBottom="3xl">
        <ListPageSkeletonPreset
          variant="executionRuns"
          showDateRange
          chartHeight={SKELETON_DEBUG_CHART_HEIGHT}
        />
      </PageShell>
    );
  }
  return <ExecutionRunsPageContent />;
};
